import {
  LAUNCH_CASE_STUDY,
  LAUNCH_CTA,
  LAUNCH_HERO,
  LAUNCH_PROBLEMS,
  LAUNCH_SEO,
  LAUNCH_SERVICES,
  LAUNCH_SERVICES_SECTION,
} from '@/data/launch';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { ServiceLineHero } from '@/components/site/service/ServiceLineHero';
import { StartingPoint } from '@/components/site/launch/StartingPoint';
import { WhatWeBuild } from '@/components/site/launch/WhatWeBuild';
import { ServiceProblems } from '@/components/site/service/ServiceProblems';
import { ProcessJourney } from '@/components/site/launch/ProcessJourney';
import { ServicePackages } from '@/components/site/service/ServicePackages';
import { EverythingTogether } from '@/components/site/launch/EverythingTogether';
import { WhyBuild } from '@/components/site/launch/WhyBuild';
import { ServiceCaseStudy } from '@/components/site/service/ServiceCaseStudy';
import { ConsultationPanel } from '@/components/site/launch/ConsultationPanel';
import { CtaBand } from '@/components/site/CtaBand';

const ACCENT = '#4225C4';
const ACCENT_DARK = '#331BA0';
const ACCENT_SOFT = '#E4E0FA';
const ENQUIRY = '/?service=launch&source=Launch%20Page#solution-finder';

export default function LaunchPage() {
  const origin = SITE_ORIGIN;

  useSeo({
    title: LAUNCH_SEO.title,
    description: LAUNCH_SEO.description,
    canonical: `${origin}/services/launch`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Amden Launch',
      provider: { '@type': 'Organization', name: 'Amden Group' },
      serviceType: 'Business launch support, planning, brand, website and systems',
      areaServed: ['Ireland', 'United Kingdom'],
      description: LAUNCH_SEO.description,
      url: `${origin}/services/launch`,
    },
  });

  return (
    <>
      <ServiceLineHero
        content={LAUNCH_HERO}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        testidPrefix="launch"
      />
      <StartingPoint />
      <WhatWeBuild />
      <ServiceProblems
        data={LAUNCH_PROBLEMS}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        index="03"
        discussHref={ENQUIRY}
        testidPrefix="launch"
        sectionClass="bg-mist"
      />
      <ProcessJourney />
      <ServicePackages
        services={LAUNCH_SERVICES}
        section={LAUNCH_SERVICES_SECTION}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        discussHref={ENQUIRY}
        id="launch-services"
        testidPrefix="launch"
        layout="grid4"
        topAccentBar
        index="05"
        discussLabel="Discuss Your Launch"
      />
      <EverythingTogether />
      <WhyBuild />
      <ServiceCaseStudy
        data={LAUNCH_CASE_STUDY}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        index="08"
        testidPrefix="launch"
      />
      <ConsultationPanel />
      <CtaBand
        index={LAUNCH_CTA.index}
        eyebrow={LAUNCH_CTA.eyebrow}
        heading={LAUNCH_CTA.heading}
        copy={LAUNCH_CTA.copy}
        primaryLabel={LAUNCH_CTA.primaryLabel}
        primaryHref={LAUNCH_CTA.primaryHref}
        secondaryLabel={LAUNCH_CTA.secondaryLabel}
        secondaryHref={LAUNCH_CTA.secondaryHref}
      />
    </>
  );
}
